export interface MusicPriceRange {
  min: number;
  max: number;
}

export interface MusicPriceReferenceItem {
  instrument: string;
  beginner: MusicPriceRange;
  lowerGrade: MusicPriceRange;
  upperGrade: MusicPriceRange;
  adultBeginner: MusicPriceRange;
}

// Indicative one-to-one hourly rates in MYR. The lower bound of every range
// reflects the requested RM10 reduction; the upper bounds remain unchanged.
export const MUSIC_PRICE_REFERENCE: MusicPriceReferenceItem[] = [
  { instrument: 'Piano', beginner: { min: 70, max: 110 }, lowerGrade: { min: 90, max: 130 }, upperGrade: { min: 115, max: 160 }, adultBeginner: { min: 80, max: 120 } },
  { instrument: 'Acoustic Guitar', beginner: { min: 55, max: 85 }, lowerGrade: { min: 70, max: 100 }, upperGrade: { min: 85, max: 125 }, adultBeginner: { min: 60, max: 90 } },
  { instrument: 'Electric Guitar', beginner: { min: 60, max: 100 }, lowerGrade: { min: 80, max: 115 }, upperGrade: { min: 100, max: 145 }, adultBeginner: { min: 70, max: 105 } },
  { instrument: 'Violin', beginner: { min: 80, max: 130 }, lowerGrade: { min: 105, max: 150 }, upperGrade: { min: 130, max: 185 }, adultBeginner: { min: 90, max: 135 } },
  { instrument: 'Flute', beginner: { min: 75, max: 115 }, lowerGrade: { min: 90, max: 135 }, upperGrade: { min: 115, max: 165 }, adultBeginner: { min: 80, max: 120 } },
  { instrument: 'Saxophone', beginner: { min: 80, max: 130 }, lowerGrade: { min: 105, max: 150 }, upperGrade: { min: 130, max: 185 }, adultBeginner: { min: 90, max: 135 } },
  { instrument: 'Drums', beginner: { min: 70, max: 110 }, lowerGrade: { min: 85, max: 125 }, upperGrade: { min: 110, max: 155 }, adultBeginner: { min: 75, max: 115 } },
  { instrument: 'Voice', beginner: { min: 55, max: 90 }, lowerGrade: { min: 70, max: 105 }, upperGrade: { min: 90, max: 135 }, adultBeginner: { min: 60, max: 95 } },
  { instrument: 'Ukulele', beginner: { min: 55, max: 90 }, lowerGrade: { min: 70, max: 105 }, upperGrade: { min: 90, max: 125 }, adultBeginner: { min: 60, max: 95 } },
];
